import React from 'react';
import { classNames } from '@fullstory/util/fmt';

export const FUNNEL_COUNTS_MIN_WIDTH = 40;

interface LabelledRectProps {
  x: number;
  y: number;
  width: number;
  height: number;
  label: string | number;
  className?: string;
  textPaddingX?: number;
  textPaddingY?: number;
  labelClassName?: string;
  alwaysShowLabel?: boolean;
  fill?: string;
  rectOverlay?: React.ReactNode;
}

export const LabelledRect: React.FC<LabelledRectProps> = ({
  x,
  y,
  width,
  label,
  className,
  height,
  labelClassName,
  alwaysShowLabel,
  textPaddingX = 8,
  textPaddingY = 6, // default of 6: font size is 12px, to vertically center, add half of font size
  fill,
  rectOverlay,
}) => (
  <>
    <rect
      x={x}
      y={y}
      width={Math.max(width, 0)}
      height={height}
      className={className}
      fill={fill}
    />
    {rectOverlay}
    {(width >= FUNNEL_COUNTS_MIN_WIDTH || alwaysShowLabel) && (
      <text
        transform={`translate(${width + x - textPaddingX}, ${y + textPaddingY})`}
        className={classNames({
          [labelClassName ?? '']: !!labelClassName,
          [className ?? '']: !!className,
        })}
      >
        {label}
      </text>
    )}
  </>
);
